import type { PostTxStatus, StatusBodyItem, TransactionDetailResponse } from '@core/models';

/**
 * Extracts the post-transaction status (value + label) from a transaction
 * detail response.
 *
 * Finds the `status` entry in `transaction_body` and reads its first metadata
 * row. Returns `null` when no status entry is present.
 *
 * Pure function — extracted from the identical detail-status blocks previously
 * duplicated in `SendStore` and `WithdrawalStore`, so the parse has a single
 * source of truth and is independently testable.
 *
 * @param detail - Response from the transaction detail endpoint
 * @returns Parsed {@link PostTxStatus}, or `null` if no status is present
 */
export function parsePostTxStatus(detail: TransactionDetailResponse): PostTxStatus | null {
  const statusItem = detail.response.transaction_body.find(
    (item): item is StatusBodyItem => item.type === 'status',
  );
  const meta = statusItem?.metadata[0];
  return meta ? { statusValue: meta.status_value, statusLabel: meta.display_value } : null;
}
